/* eslint-disable @typescript-eslint/no-magic-numbers */
import { useTranslation } from 'react-i18next';

import { useCenterValidationSchema } from '@/pages/CenterValidation/schema/CenterValidationSchema';
import { string } from '@/utils/validation';

export const useAtHomeProgramAndAccessSchema = () => {
  const { programCode } = useCenterValidationSchema();
  const { t } = useTranslation('apiError');

  return {
    programCode,
    accessCode: string()
      .minLength(6, t('atHomeAccessCodeMinLengthValidation'))
      .maxLength(128, t('adminCodeMaxLengthValidation'))
      .alphaNumericWithUnderscores(t('adminCodeWithUnderscores'))
      .required(t('atHomeAccessCodeRequired')),
  };
};
export default useAtHomeProgramAndAccessSchema;
